import React from 'react'
import { Col,  Breadcrumb } from 'react-bootstrap';
import PropTypes from 'prop-types';
//icons
import { FaHome } from "react-icons/fa";

const BreadCrumb = ({breadcrumbTitle}) => {
  return (
    <Col lg={12} className="mx-0 breadcrumb-container">
      <Breadcrumb className='breadcrumb-nav'>
        <Breadcrumb.Item href="/">
          <FaHome className="icon-svg" />
        </Breadcrumb.Item>
        <Breadcrumb.Item active>{breadcrumbTitle}</Breadcrumb.Item>
      </Breadcrumb>
    </Col>
  )
}

PropTypes.BreadCrumb = {
  breadcrumbTitle: PropTypes.string
}
export default BreadCrumb
